var map = {
	"./benefits.svg": 3858,
	"./cancer.svg": 2343,
	"./checkmark.svg": 3538,
	"./clipboard-checklist.svg": 5992,
	"./computer-select-test.svg": 78,
	"./documents.svg": 6233,
	"./documents_small.svg": 1829,
	"./eye.svg": 648,
	"./guide.svg": 2444,
	"./icon-ir.svg": 8568,
	"./immunology.svg": 5550,
	"./insurance.svg": 4027,
	"./insurance_small.svg": 3315,
	"./location.svg": 486,
	"./medicine.svg": 1629,
	"./newspaper.svg": 4723,
	"./outliner-detection.svg": 7916,
	"./profile.svg": 4453,
	"./profile_small.svg": 6116,
	"./share.svg": 8909,
	"./unified-workflow.svg": 5897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4801;